import styled from '@emotion/styled';
import {mainColors} from '../../../../../assets/colors';

export const SelectWrapper = styled('label', { label: 'SelectWrapper' })`
    display: block;
    margin-bottom: 15px;
`;

export const SelectLabel = styled('span', { label: 'SelectLabel' })`
   display: block;
   font-size: 12px;
   color: ${mainColors.grays.gray400};
`;

export const SelectElement = styled('select', { label: 'SelectElement' })`
    line-height: 30px;
    height: 32px;
    font-size: 14px;
    color: ${mainColors.default.dark};
    border: 1px solid ${mainColors.grays.gray200};
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
    background-color: transparent;
`;

export const EmptyOption = styled('option', { label: 'EmptyOption' })`
    display: none;
`;
